import { List, Map, fromJS } from 'immutable';
import { listFindByMapId } from 'core/generalFunctions';
import * as constAction from 'root/actionConstants';

const defaultState = Map({
  lista: List(),
  abonado: Map(),
  abonadoReservasAutomaticas: Map(),
  abonadoLastAbonos: List(),
  abonadosActivos: List(),
  trayectoSeleccionado: Map(),
  eliminarId: false,
  reservasUsuario: List(),
  blockForm: false,
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.ABONADOS_CLEAR: {
      if (action.payload === 'all') return defaultState;
      else if (defaultState.has(action.payload)) return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad ' + action.payload);
        return state;
      }
    }
    case constAction.ABONADOS_SET_STATE: {
      let newState = state;
      for (var key in action.payload) newState = newState.set(key, fromJS(action.payload[key]));
      return newState;
    }
    case constAction.ABONADOS_SET_IN_STATE: {
      return state.setIn(action.payload.key, action.payload.value);
    }
    case constAction.ABONADOS_ADDOREDIT_RA: {
      let { RA, i, trayectoId, pathEdit } = action.payload;
      if (pathEdit && RA) {
        pathEdit.unshift('abonadoReservasAutomaticas');
        return state.setIn(pathEdit, fromJS(RA));
      }
      return state.updateIn(['abonadoReservasAutomaticas', trayectoId, i], arr => (arr ? arr.push(fromJS(RA)) : List().push(fromJS(RA))));
    }
    case constAction.ABONADOS_DELETESTATE_RA: {
      return state.deleteIn(['abonadoReservasAutomaticas'].concat(action.payload));
    }
    case constAction.ABONADOS_DELETE_STATE: {
      if (action.payload.key) {
        let index = listFindByMapId(state.get(action.payload.key), action.payload.id, true);
        return state.deleteIn([action.payload.key, index]);
      } else return state.deleteIn(action.payload);
    }
    case constAction.ABONADOS_RESERVAS_AUTOMATICAS_SET_STATE: {
      let reservasOrganizadas = Map();
      const raAbonados = fromJS(action.payload);
      if (raAbonados && raAbonados.groupBy)
        raAbonados
          .groupBy(reservaAutomatica => reservaAutomatica.get('trayectoId'))
          .map((data, i) => {
            reservasOrganizadas = reservasOrganizadas.set(
              i,
              data.groupBy(dia => dia.get('dia')),
            );
          });
      return state.set('abonadoReservasAutomaticas', reservasOrganizadas);
    }
    case constAction.ABONADOS_SET_LISTA: {
      let lista = List();
      const payload = fromJS(action.payload);

      lista = lista.set(
        0,
        (payload.get(0) || List()).sortBy(abonado => {
          if (abonado.getIn(['_reservas', 0, 'fechaRealizada'])) return -new Date(abonado.getIn(['_reservas', 0, 'fechaRealizada'])).getTime();
          else return false;
        }),
      );

      lista = lista.set(
        1,
        (payload.get(1) || List()).sortBy(abonado => {
          if (abonado.getIn(['_reservas', 0, 'fechaRealizada'])) return -new Date(abonado.getIn(['_reservas', 0, 'fechaRealizada'])).getTime();
          else return false;
        }),
      );

      return state.set('lista', lista);
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/modules/abonados/reducer.js